<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">

                 <div class="card-header mb-5 d-flex flex-between-center">
                    <div class="d-flex align-items-center">
                        <h2>Транзакции</h2>
                    </div>

                    <div class="d-flex">
                        <a 
                            @click="newDate"
                            class="btn btn-primary mb-1 float_right">Новая дата</a>
                    </div>
                </div>


                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>

                <div class="row g-5" v-if="!preloader">
                    <div class="col-xl-12 mb-5">
                        <form class="row g-3" v-on:submit.prevent="update">

                            <template v-for="(item, index_date) in data.transactions">

                                <div class="card-header p-2 mt-1 d-flex flex-between-center" style="margin-bottom: -10px;">
                                    <div class="d-flex align-items-center">
                                        <h2 class="fs-1">Транзакции</h2>
                                    </div>

                                    <div class="d-flex">
                                        <a 
                                            @click="newTransaction(index_date)"
                                            class="btn btn-primary mb-1 float_right">Новая транзакция</a>
                                        <a 
                                            @click="deleteDate(index_date)"
                                            class="btn btn-danger mb-1 float_right"
                                            style="margin-left: 5px;">Удалить</a>
                                    </div>
                                </div>


                                <div class="col-sm-12 col-md-12">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.transactions[index_date].date"
                                            placeholder="Дата"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Дата</label>
                                    </div>
                                </div>

                                <div class="row g-2" style="margin-left: 0px;" v-for="(item, index) in item.transactions">

                                    <div class="col-sm-6 col-md-2">
                                        <div class="form-floating v-select-medium">
                                            <div>
                                                <vue-select
                                                    v-model="data.transactions[index_date].transactions[index].type"
                                                    :options="utils.transaction_types"
                                                    label="name"
                                                    placeholder="Тип транзакции">
                                                    <template v-slot:no-options="{ search, searching }">
                                                      <template v-if="searching">
                                                         Ничего не найдено по запросу <em>{{ search }}</em>.
                                                      </template>
                                                    </template>
                                                </vue-select>
                                                <label class="custom-select-label">Тип транзакции</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-2 col-md-2">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.transactions[index_date].transactions[index].wallet"
                                                placeholder="Кошелек"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Кошелек</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-2 col-md-2">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.transactions[index_date].transactions[index].amount"
                                                placeholder="Сумма"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Сумма</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-2 col-md-2">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.transactions[index_date].transactions[index].amount_usd"
                                                placeholder="Сумма в $"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Сумма в $</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-2 col-md-2">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.transactions[index_date].transactions[index].date"
                                                placeholder="Дата"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Дата</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 col-md-2">
                                        <div class="form-floating v-select-medium select-both-button-row">
                                            <button
                                                style="height: 48px"
                                                @click="changeTransactionStatus(index_date, index)"
                                                :content="data.transactions[index_date].transactions[index].status == 1 ? 'Отключить' : 'Включить'" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                type="button"
                                                class="btn btn-soft-secondary select-button-right">
                                                <span class="vertical-center-icon">
                                                    <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.transactions[index_date].transactions[index].status == 1, 'fa-play': data.transactions[index_date].transactions[index].status == 0}"></i>
                                                </span>
                                            </button>

                                            <button
                                                style="height: 48px"
                                                @click="deleteTransaction(index_date, index)"
                                                content="Удалить" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                type="button"
                                                class="btn btn-soft-danger select-button-right-2">
                                                <span class="vertical-center-icon">
                                                    <i class="icon-paysystem fa-regular fa-trash"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                </div>

                                <hr class="mt-5" v-if="index_date < data.transactions.length - 1"/>
                            </template>

                            <div class="col-sm-3 col-md-3 mt-5">
                                <button class="btn btn-primary px-5 w-100 text-nowrap" type="submit" :class="{'disabled': btn_preloader}">
                                    <span class="spinner-border spinner-border-sm spinner-border-custom" role="status" v-if="btn_preloader"></span>
                                    <span>Сохранить</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>
export default {
    props: ['id'],
    data () {
        return {
            preloader: true,
            btn_preloader: false,
            data: {

                transactions: [
                    {
                        date: 'апр. 22 2024',
                        transactions: [
                            {
                                type: {
                                    name: 'Send',
                                    key: 'send'
                                },
                                wallet: null,
                                amount: null,
                                amount_usd: null,
                                status: 1
                            }
                        ]
                    },
                    {
                        date: 'апр. 21 2024',
                        transactions: [
                            {
                                type: {
                                    name: 'Receive',
                                    key: 'receive'
                                },
                                wallet: null,
                                amount: null,
                                amount_usd: null,
                                status: 1
                            }
                        ]
                    }
                ]
            },
            utils: {
                transaction_types: [
                    {
                        name: 'Receive',
                        key: 'receive'
                    },
                    {
                        name: 'Send',
                        key: 'send'
                    }
                ]
            }
        }
    },
    methods: {
        getItem () {
            this.$axios.post('/trustwallet/item/transactions')
            .then(async (response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        this.data = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        update () {
            this.btn_preloader = true
            this.$axios.post('/trustwallet/transactions/update', JSON.stringify(this.data))
            .then((response) => {
                this.btn_preloader = false
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        this.$toast.success(response.message)

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.btn_preloader = false
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    if('field' in response) {
                        this.errorByPatch(this.errors, response.field, response.message)
                    } else {
                        this.$toast.error(response.message)
                    }
                }
            })
        },
        errorByPatch (layer, path, value) {
            path = path.split('.')

            path.forEach((value, index) => {
                if (!isNaN(value)) {
                    path[index] = parseInt(value)
                }
            })

            for (var i = 0; i < path.length; i++) {
                if (value != null && i + 1 === path.length) {
                    layer[path[i]] = value
                }
                layer = layer[path[i]]
            }
            return layer
        },
        newDate () {
            this.data.transactions.push({
                date: 'апр. 22 2024',
                transactions: [
                    {
                        type: {
                            name: 'Receive',
                            key: 'receive'
                        },
                        wallet: null,
                        amount: null,
                        status: 1
                    }
                ]
            })
        },
        deleteDate (index_date) {
            if(this.data.transactions.length > 1) {
                this.data.transactions.splice(index_date, 1)
            }
        },


        newTransaction(index_date) {
            this.data.transactions[index_date].transactions.push({
                type: {
                    name: 'Receive',
                    key: 'receive'
                },
                wallet: null,
                amount: null,
                status: 1
            })
        },

        deleteTransaction(index_date, index) {
            if(this.data.transactions[index_date].transactions.length > 1) {
                this.data.transactions[index_date].transactions.splice(index, 1)
            }
        },

        changeTransactionStatus (index_date, index) {
            this.data.transactions[index_date].transactions[index].status = this.data.transactions[index_date].transactions[index].status ? 0 : 1
        }
    },
    beforeMount() {
        this.getItem()
    }
}
</script>

<style lang="css" scoped>
    ::v-deep .vs__clear {
        display: none;
    }
    /*::v-deep .vs__selected {
        font-size: 10px !important;
    }*/
    ::v-deep .vs__dropdown-toggle {
        max-height: 48px;
    }
</style>
